import React, {useMemo, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {Avatar, Card, CardContent, DialogContent} from "@material-ui/core";
import {EnhancedTableToolbar} from "./TableToolbar";
import AntDataGrid from "../../../shared/components/AntDataGrid";
import {nanoid} from "@reduxjs/toolkit";
import {Col, Row, Tag} from "antd";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Divider from "@material-ui/core/Divider";
import DirectionsIcon from "@material-ui/icons/Directions";
import {useForm} from "react-hook-form";
import {statusColors} from "../constants";
import {DateTime} from "luxon";
import {epochToDate} from "../../../shared/functions/toDateTime";
import ImageModal from './ImageModal';
import Button from '@material-ui/core/Button';
 

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        color: 'white'
    },
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function PurchaseCartModal({items, show, onClose}) {
    const fontSize = 18;
    const classes = useStyles();
    const {register, handleSubmit} = useForm();
    const [filtered, setFiltered] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [open, setOpen] = useState(null);
    const [url, setUrl] = useState('');
    
    const [canChangeStatus, setCanChangeStatus] = useState(false);

    const handleOpen = (_url) => {
        setUrl(_url)
        setOpen(true);
    };

    const handleCloseD = () => {
        setOpen(false);
    };


    const columns = [
        {
            title: '', dataIndex: 'image', key: 'image',
            render: (imageItem) => {
                return (
                    <React.Fragment>
                        {
                            imageItem && <Avatar onClick={() => handleOpen(imageItem)} alt={'...'} src={imageItem}/>
                        }
                        {open && url === imageItem && <ImageModal
                            url={url}
                            open={open}
                            handleClose={handleCloseD}
                        />
                        }
                    </React.Fragment>
                )
            }
        },
        {title: 'Prosoft Id', dataIndex: 'proSoftId', key: 'proSoftId'},
        {title: 'Barcode', dataIndex: 'barcode', key: 'barcode'},
        {title: 'Name', dataIndex: 'name', key: 'name'},
        {title: 'Price', dataIndex: 'price', key: 'price'},
        {title: 'Qty.', dataIndex: 'quantity', key: 'quantity'},
        {title: 'Ship.', dataIndex: 'shippedQuantity', key: 'shippedQuantity'},
        {title: 'Disc.', dataIndex: 'discount', key: 'discount'},
        {title: 'Amount', dataIndex: 'amount', key: 'amount', render: value => (value || 0)?.toFixed(2)},
        {title: 'Recv.', dataIndex: 'isReceived', key: 'isReceived', render: value => String(value)},
        {title: 'Sell P.', dataIndex: 'sellPrice', key: 'sellPrice'},
        {title: 'Expires', dataIndex: 'expires', key: 'expires'},
    ];

    const list = useMemo(() => {


        if (!items) return [];

        let copy = []

        if (items && items.Purchases) 
            for (const item of items.Purchases) {
                copy.push({
                    key: nanoid(),
                    id: item.ItemId,
                    image: item.ImagrUrl,
                    name: item.Name,
                    barcode: item.Barcode,
                    proSoftId: item.InternalId,
                    price: item.Price,
                    quantity: item.Quantity,
                    shippedQuantity: item.ShippedQuantity,
                    discount: item.Discount,
                    amount: item.Amount,
                    isReceived: item.Received,
                    sellPrice: item.SellPrice,
                    ClassItem: item.ClassItem,
                    Threshold: item.Threshold,
                    HasClilds: item.HasClilds,
                    expires: item.ExpirationDate && epochToDate(item.ExpirationDate),
                })

            }

        return copy;
        

    }, [items])

    console.log(JSON.stringify(list));
 
    
    const totalCost = useMemo(() => {

        let total = 0;

        for (const {price, quantity, discount} of list) {
            total += (price - discount) * quantity;
        }

        return (total || 0)?.toFixed(2)

    }, [list]);


    const totalItem = useMemo(() => {

        let totals = 0;

        for (const { quantity} of list) {
            totals += quantity;
        }

        return (totals || 0)

    }, [list]);
 
    const totalVariety = useMemo(() => list.length, [list])

    const ref = useMemo(() => {
        const toString = String(items.PoRef);
        const numberOfZero = 10 - toString.length;
        return `Po-${'0'.repeat(numberOfZero)}${toString}`
    }, [items])
    const {
        VendorName,
        StoreName,
        Username,
        DeliveryType,
        ActivityStatus,
        ShippingFee,
        Tax,
        OtherFee,
        CreateAt,
        UpdateAt,
        Currency
    } = items;

    const createdAt = DateTime.fromJSDate(CreateAt.toDate()).toFormat('dd-MM-yyyy')
    const updatedAt = DateTime.fromJSDate(UpdateAt.toDate()).toFormat('dd-MM-yyyy')

    const handleClose = () => {
        onClose && onClose()
        setIsSearching(false)
    }

    const handleSearch = ({keyword}) => {
        let segments = keyword.split(' ');

        let filtered = []

        for (const segment of segments) {
            const found = list.filter(item => {
                return item?.name?.toLowerCase().includes(segment.toLowerCase())
                    || item?.proSoftId?.toLowerCase().includes(segment.toLowerCase())
                    || item?.barcode?.toLowerCase().includes(segment.toLowerCase());

            })

            found.forEach(item => {
                if (!filtered.find(one => one.id === item.id))
                    filtered.push(item)
            })

        }

        setFiltered(filtered)
        setIsSearching((segments.length > 0 && segments[0] !== '')) 
    }

    const handleClearSearchBox = () => setIsSearching(false)


    return (
        <>
        <Dialog fullScreen open={show} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>

                    <Typography variant="h6" className={classes.title}>
                        {`${ref} | ${VendorName}  (${StoreName})`}
                    </Typography>


                    <Row className='mr-2'>
                        <Col>
                            <Tag color={statusColors(ActivityStatus)} style={{fontSize: 25, padding: 7}}>
                                {ActivityStatus}
                            </Tag>
                        </Col>
                    </Row>

                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">

                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>

            <DialogContent>

                <Row>
                    <Card style={{width: '100%', boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)"}}>
                        <CardContent>
                            <Row>
                                <Col>

                                    <div style={{height: 10}}/>

                                    <Tag color='green'>
                                        <h5>{DeliveryType}</h5>
                                    </Tag>

                                    <div style={{height: 10}}/>

                                    <p style={{fontSize: fontSize}}><b>User:</b> {Username}  </p>

                                    <p style={{fontSize: fontSize}}><b>Created at :</b> {createdAt}  </p>

                                    <p style={{fontSize: fontSize}}><b>Updated at :</b> {updatedAt}  </p>
                                </Col>

                                <Col className='ml-auto'>


                                    {
                                        ShippingFee && (
                                            <p style={{fontSize: fontSize}}><b> Shipping fees :</b> {ShippingFee}  </p>
                                        )
                                    }

                                    {
                                        Tax && (
                                            <p style={{fontSize: fontSize}}><b> Tax :</b> {Tax}  </p>
                                        )
                                    }


                                    {
                                        OtherFee && (
                                            <p style={{fontSize: fontSize}}><b> Other fees :</b> {OtherFee}  </p>
                                        )
                                    }


                                    <p style={{fontSize: fontSize}}><b>Total items:</b> {totalItem}  </p>

                                    <p style={{fontSize: fontSize}}><b>Total Variety of items:</b> {totalVariety}  </p>

                                    <p style={{fontSize: fontSize}}><b>Total Amount:</b> {Currency === "FCFA" ? `${totalCost} F CFA` : `$ ${totalCost}`}  </p>


                                </Col>


                            </Row>

                        </CardContent>
                    </Card>
                </Row>

                <div style={{height: 40}}/>
                
                <Row>
                    <Col item xs={9}>
                        <Paper component="form" className={classes.root} onSubmit={handleSubmit(handleSearch)}>
                            <InputBase
                                className={classes.input}
                                placeholder="Search..."
                                inputProps={{'aria-label': 'search...'}}
                                {...register('keyword')}
                                onChange={event => handleSearch({keyword: event.target.value})}
                            />
                            <IconButton type="submit" className={classes.iconButton} aria-label="search">
                                <SearchIcon/>
                            </IconButton>
                            <Divider className={classes.divider} orientation="vertical"/>
                            <IconButton color="primary" type='reset' onClick={handleClearSearchBox}
                                        className={classes.iconButton} aria-label="directions">
                                <DirectionsIcon/>
                            </IconButton>
                        </Paper>
                    </Col>
                    <Col item xs={3}>
                        {
                            Currency === "FCFA" && <Button onClick={() => setCanChangeStatus(true)} color="primary" variant="contained">
                            Change status 
                        </Button>
                        }
                        
                    </Col>

                </Row>

                <div style={{height: 10}}/>

                <AntDataGrid
                    columns={columns}
                    data={isSearching ? filtered : list}
                    size={'large'}
                    Currency = {Currency}
                    ToolBar={EnhancedTableToolbar}
                />

            </DialogContent>

        </Dialog>
             
        </>
        
    );
}
